<script>
  export let width;
  export let height;

</script>

<svg
  class="missingImage"
  width={`${width}px`}
  height={`${height}px`}
  viewBox="0 0 46 46"
  version="1.1"
  xmlns="http://www.w3.org/2000/svg"
>
  <g id="Page-1" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
    <g id="Option-1---Table-Product" transform="translate(-1095.000000, -950.000000)">
      <g id="Product" transform="translate(250.000000, 917.000000)">
        <g id="Details" transform="translate(36.000000, 15.000000)">
          <g id="ic_photo_black_24px" transform="translate(802.000000, 11.000000)">
            <polygon id="Shape" points="0 0 60 0 60 60 0 60" />
            <path
              d="M52.5,47.5 L52.5,12.5 C52.5,9.75 50.25,7.5 47.5,7.5 L12.5,7.5 C9.75,7.5 7.5,9.75 7.5,12.5 L7.5,47.5 C7.5,50.25 9.75,52.5 12.5,52.5 L47.5,52.5 C50.25,52.5 52.5,50.25 52.5,47.5 Z M21.25,33.75 L27.5,41.275 L36.25,30 L47.5,45 L12.5,45 L21.25,33.75 Z"
              id="Shape"
              fill="#BABABA"
              fillRule="nonzero"
            />
          </g>
        </g>
      </g>
    </g>
  </g>
</svg>
